import { Box, Link, Typography } from '@mui/material'

import BasicDialog from '../../components/m3/basic-dialog'

import { LocateCodeImages } from './activation-instructions'
import classes from './index.styles'

interface HelpDialogProps {
  open: boolean
  onClose: () => void
}

export const HelpDialog = ({ open, onClose }: HelpDialogProps) => (
  <BasicDialog
    open={open}
    onClose={onClose}
    title="Need help?"
    textContent={
      <>
        <Typography variant="body2" color="text.secondary" sx={classes.helpDialogText}>
          Contact Sensor Support:
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={classes.helpDialogText}>
          Call{' '}
          <Link href="tel:8444681866" style={classes.contactLink}>
            (844) 468-1866
          </Link>
          <br />
          Monday–Friday 8am-8pm EST
          <br />
          Email{' '}
          <Link href="mailto:sensorsupport@hsb.com" style={classes.contactLink}>
            sensorsupport@hsb.com
          </Link>
        </Typography>
      </>
    }
    showCloseIcon
    hideCancelButton
    confirmLabel="OK, got it"
    onConfirm={onClose}
  />
)

interface LocateCodeDialogProps {
  open: boolean
  onClose: () => void
}

export const LocateCodeDialog = ({ open, onClose }: LocateCodeDialogProps) => (
  <BasicDialog
    open={open}
    onClose={onClose}
    title="Locate your code"
    showCloseIcon
    textContent={
      <>
        <Typography variant="body2" color="text.secondary">
          Turn over your Leak & Freeze device and locate the code on the sticker. Choose the device that matches this code on the list and complete activation.
        </Typography>

        <Box sx={classes.locateCodeImagesRow}>
          <LocateCodeImages />
        </Box>
      </>
    }
    hideCancelButton
    confirmLabel="Got it"
    onConfirm={onClose}
  />
)

interface FinalizeDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export const FinalizeDialog = ({ open, onClose, onConfirm }: FinalizeDialogProps) => (
  <BasicDialog
    open={open}
    onClose={onClose}
    closeLabel="Activate More"
    onConfirm={onConfirm}
    confirmLabel="Complete Install"
    title="Finished so soon?"
    showCloseIcon
    textContent={'You still have devices that should be activated. If you chose to complete activation, these devices will be marked as \u201cextra\u201d.'}
  />
)
